import { mainApi } from '@/lib/api';
import { ServerPageData } from '@/features/product-editor/types';

export async function movePage(storeId: number, pageId: number, moveTo: 'landing' | 'store'): Promise<void> {
    await mainApi.patch(`v1/stores/${storeId}/pages/${pageId}/move`, { move_to: moveTo });
}

export async function hidePage(storeId: number, pageId: number): Promise<void> {
    await mainApi.patch(`v1/stores/${storeId}/pages/${pageId}/hide`);
}

export async function deletePage(storeId: number, pageId: number): Promise<void> {
    await mainApi.delete(`v1/stores/${storeId}/pages/${pageId}`);
}

// TODO: Verify
export async function getPageDetails(storeId: number, pageId: number): Promise<ServerPageData> {
    const response = await mainApi.get(`v1/stores/${storeId}/pages/${pageId}`);
    return response.data.data;
}

export async function upsertPublishedPage(storeId: number, pageData: ServerPageData): Promise<any> {
    const response = await mainApi.put(`v1/stores/${storeId}/pages`, pageData);
    return response.data;
}

export async function upsertDraftPage(storeId: number, pageData: Partial<ServerPageData>): Promise<any> {
    const response = await mainApi.put(`v1/stores/${storeId}/pages/draft`, pageData);
    return response.data;
}
